// @ts-nocheck
import * as Types from "../../../../../../../types/types";

import { gql } from "@apollo/client";
import {
  IncidentIoDeliveryFieldsFragmentDoc,
  WebhookDeliveryFieldsFragmentDoc,
} from "./Fragment.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type RetryWebhookDeliveryMutationVariables = Types.Exact<{
  webhookDeliveryId: Types.Scalars["ID"]["input"];
}>;

export type RetryWebhookDeliveryMutation = {
  __typename?: "Mutation";
  retryWebhookDelivery?: {
    __typename?: "WebhookDelivery";
    id: string;
    eventId: string;
    eventType: string;
    status: string;
    attempts: number;
    nextAttemptAt?: number | null;
    lastAttemptAt?: number | null;
    responseStatus?: number | null;
    responseBodyExcerpt?: string | null;
    errorKind?: string | null;
    errorMessage?: string | null;
    payload: any;
    createdAt: number;
    issue?: {
      __typename?: "Issue";
      id: string;
      description: string;
      checkGroupAndName: string;
      server: {
        __typename?: "Server";
        id: string;
        humanId: string;
        name: string;
      };
      database?: { __typename?: "Database"; id: string } | null;
    } | null;
  } | null;
};

export type RetryIncidentIoDeliveryMutationVariables = Types.Exact<{
  incidentIoDeliveryId: Types.Scalars["ID"]["input"];
}>;

export type RetryIncidentIoDeliveryMutation = {
  __typename?: "Mutation";
  retryIncidentIoDelivery?: {
    __typename?: "IncidentIoDelivery";
    id: string;
    deduplicationKey: string;
    eventType: string;
    status: string;
    attempts: number;
    nextAttemptAt?: number | null;
    lastAttemptAt?: number | null;
    responseStatus?: number | null;
    responseBodyExcerpt?: string | null;
    errorKind?: string | null;
    errorMessage?: string | null;
    payload: any;
    createdAt: number;
    issue?: {
      __typename?: "Issue";
      id: string;
      description: string;
      checkGroupAndName: string;
      server: {
        __typename?: "Server";
        id: string;
        humanId: string;
        name: string;
      };
      database?: { __typename?: "Database"; id: string } | null;
    } | null;
  } | null;
};

export const RetryWebhookDeliveryDocument = gql`
  mutation RetryWebhookDelivery($webhookDeliveryId: ID!) {
    retryWebhookDelivery(webhookDeliveryId: $webhookDeliveryId) {
      ...WebhookDeliveryFields
    }
  }
  ${WebhookDeliveryFieldsFragmentDoc}
`;
export type RetryWebhookDeliveryMutationFn = Apollo.MutationFunction<
  RetryWebhookDeliveryMutation,
  RetryWebhookDeliveryMutationVariables
>;

/**
 * __useRetryWebhookDeliveryMutation__
 *
 * To run a mutation, you first call `useRetryWebhookDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryWebhookDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryWebhookDeliveryMutation, { data, loading, error }] = useRetryWebhookDeliveryMutation({
 *   variables: {
 *      webhookDeliveryId: // value for 'webhookDeliveryId'
 *   },
 * });
 */
export function useRetryWebhookDeliveryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetryWebhookDeliveryMutation,
    RetryWebhookDeliveryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RetryWebhookDeliveryMutation,
    RetryWebhookDeliveryMutationVariables
  >(RetryWebhookDeliveryDocument, options);
}
export type RetryWebhookDeliveryMutationHookResult = ReturnType<
  typeof useRetryWebhookDeliveryMutation
>;
export type RetryWebhookDeliveryMutationResult =
  Apollo.MutationResult<RetryWebhookDeliveryMutation>;
export type RetryWebhookDeliveryMutationOptions = Apollo.BaseMutationOptions<
  RetryWebhookDeliveryMutation,
  RetryWebhookDeliveryMutationVariables
>;
export const RetryIncidentIoDeliveryDocument = gql`
  mutation RetryIncidentIoDelivery($incidentIoDeliveryId: ID!) {
    retryIncidentIoDelivery(incidentIoDeliveryId: $incidentIoDeliveryId) {
      ...IncidentIoDeliveryFields
    }
  }
  ${IncidentIoDeliveryFieldsFragmentDoc}
`;
export type RetryIncidentIoDeliveryMutationFn = Apollo.MutationFunction<
  RetryIncidentIoDeliveryMutation,
  RetryIncidentIoDeliveryMutationVariables
>;

/**
 * __useRetryIncidentIoDeliveryMutation__
 *
 * To run a mutation, you first call `useRetryIncidentIoDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryIncidentIoDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryIncidentIoDeliveryMutation, { data, loading, error }] = useRetryIncidentIoDeliveryMutation({
 *   variables: {
 *      incidentIoDeliveryId: // value for 'incidentIoDeliveryId'
 *   },
 * });
 */
export function useRetryIncidentIoDeliveryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetryIncidentIoDeliveryMutation,
    RetryIncidentIoDeliveryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RetryIncidentIoDeliveryMutation,
    RetryIncidentIoDeliveryMutationVariables
  >(RetryIncidentIoDeliveryDocument, options);
}
export type RetryIncidentIoDeliveryMutationHookResult = ReturnType<
  typeof useRetryIncidentIoDeliveryMutation
>;
export type RetryIncidentIoDeliveryMutationResult =
  Apollo.MutationResult<RetryIncidentIoDeliveryMutation>;
export type RetryIncidentIoDeliveryMutationOptions = Apollo.BaseMutationOptions<
  RetryIncidentIoDeliveryMutation,
  RetryIncidentIoDeliveryMutationVariables
>;
